import { render, staticRenderFns } from "./TenantSubscriptionPlan.vue?vue&type=template&id=994f2376&"
import script from "./TenantSubscriptionPlan.vue?vue&type=script&lang=ts&"
export * from "./TenantSubscriptionPlan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports